/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Util from './util'
import _ from 'underscore'
import Backbone from '@polleverywhere/backbone'

const fetchCsrfToken = () =>
  Backbone.ajax({
    method: 'GET',
    url: '/api/csrf_token',
    cache: false
  })

const isInvalidCsrfTokenError = jqXHR =>
  (jqXHR.status === 422) &&
    (__guard__(jqXHR.responseJSON != null ? jqXHR.responseJSON.error : undefined, x => x.type) === 'InvalidAuthenticityToken')

// @namespace Ajax.Csrf
class Retry {
  constructor (cache, nextAjax) {
    this.ajax = this.ajax.bind(this)
    this.nextAjax = nextAjax
    if (!cache.csrf) { cache.csrf = {} }
    this.tokens = cache.csrf.tokens || (cache.csrf.tokens = {})
  }

  ajax (options) {
    if (!Util.requiresCsrfToken(this.tokens, options) || options.csrfRetry) {
      // Short circut because this request doesn't require a retry
      return this.nextAjax(options)
    }

    /*
     * NOTE: We need to be careful that callbacks are triggered in the correct order.
     *       See: http://api.jquery.com/jquery.ajax/#callback-functions
     */

    /*
     * overwrite *current request* callbacks so we can call them
     * in the correct order later on
     */
    const originalOptions = _.pick(options, 'error', 'complete', 'success')
    options.error = (options.complete = (options.success = Backbone.$.noop()))
    const deferRequest = Backbone.$.Deferred()
    const req = this.nextAjax(options)

    req.done(function () {
      // Make sure callbacks in order of success, done, complete
      if (typeof originalOptions.success === 'function') {
        originalOptions.success(...arguments)
      }
      if (originalOptions.complete) { deferRequest.done(originalOptions.complete) }
      return deferRequest.resolve(...arguments)
    })

    req.fail(function () {
      /*
       * handle as a normal error unless it's the first time receiving an
       * invalid CSRF token
       */
      if (isInvalidCsrfTokenError(req)) {
        return fetchCsrfToken()
          .done(function (data, textStatus, jqXHR) {
            _.extend(options, originalOptions)
            options.csrfRetry = true
            /*
             * This will set the error, success, and complete callbacks back up
             * and the deferRequest should have any done / fail promise callbacks
             */
            return Backbone.ajax(options)
              .done(deferRequest.resolve)
              .fail(deferRequest.reject)
          }).fail(function () {
            __guardMethod__(console, 'warn', o => o.warn('Failed to get new CSRF token'))
            if (typeof originalOptions.error === 'function') {
              originalOptions.error(...arguments)
            }
            if (originalOptions.complete) { deferRequest.fail(originalOptions.complete) }
            return deferRequest.reject(...arguments)
          })
      } else {
        if (typeof originalOptions.error === 'function') {
          originalOptions.error(...arguments)
        }
        if (originalOptions.complete) { deferRequest.fail(originalOptions.complete) }
        return deferRequest.reject(...arguments)
      }
    })
    return deferRequest.promise(req)
  }
}

export default Retry

function __guard__ (value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}
function __guardMethod__ (obj, methodName, transform) {
  if (typeof obj !== 'undefined' && obj !== null && typeof obj[methodName] === 'function') {
    return transform(obj, methodName)
  } else {
    return undefined
  }
}
